import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const Docs = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="12"
        height="16"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.08333 8.41667H8.91667V7.08333H3.08333V8.41667ZM3.08333 10.9167H8.91667V9.58333H3.08333V10.9167ZM3.08333 13.4167H6.70833V12.0833H3.08333V13.4167ZM1.49417 16C1.08139 16 0.729167 15.8531 0.4375 15.5594C0.145833 15.2656 0 14.9125 0 14.5V1.5C0 1.0875 0.146875 0.734376 0.440625 0.440626C0.734375 0.146876 1.0875 0 1.5 0H8L12 4V14.5C12 14.9125 11.8531 15.2656 11.5592 15.5594C11.2653 15.8531 10.9119 16 10.4992 16H1.49417ZM7 5V1.5H1.5V14.5H10.5V5H7Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  )
}

Docs.muiName = SvgIcon.muiName
export default Docs
